import { render } from "./CommonCreatorCard.vue?vue&type=template&id=79fb7f60&scoped=true"
import script from "./CommonCreatorCard.vue?vue&type=script&lang=js"
export * from "./CommonCreatorCard.vue?vue&type=script&lang=js"

import "./CommonCreatorCard.vue?vue&type=style&index=0&id=79fb7f60&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fb7f60"]])

export default __exports__